import { MenuItem } from 'src/app/models/common/menu-item';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MenuService } from '../services/menu.service';

import { HeaderService } from '../services/header.service';
import { AuthService } from 'src/app/auth.service';
import { SettingService } from '../services/setting.service';
declare const setScrollAndScreenHeight: any;

@Component({
  selector: 'sym-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit {
  @Output() titleSelected = new EventEmitter<any>();

  userName: string;
  userImage: string;
  userImageName: string;
  imageUrl: string;
  isUserDropdownOpen: boolean;
  constructor(
    public service: MenuService,
    public headerService: HeaderService,
    public authService: AuthService,
    public settingService: SettingService
  ) {
    //this.userName = JSON.parse(this.settingService.getSessionStorageValue('USER'));
    this.userName =
      this.service.getUserLoginData() != undefined && this.service.getUserLoginData()['UserName'] != undefined
        ? this.service.getUserLoginData()['UserName']
        : JSON.parse(this.settingService.getSessionStorageValue('USER'));
    this.isUserDropdownOpen = false;

    let parsedUserImage: string | null = null;
    const raw = this.settingService.getSessionStorageValue('UserImage');
    parsedUserImage =
      raw !== undefined && raw !== 'undefined' && raw != null ? JSON.parse(JSON.stringify(raw)) : null;
    this.userImage = this.service.getUserLoginData()['UserImage'] ?? parsedUserImage ?? null;
    this.userImage = this.hexToBase64(this.userImage);

    let parsedUserImageName: string | null = null;
    const raw1 = this.settingService.getSessionStorageValue('UserImageName');
    parsedUserImageName =
      raw1 !== undefined && raw1 !== 'undefined' && raw1 != null ? JSON.parse(JSON.stringify(raw1)) : null;
    this.userImageName = this.service.getUserLoginData()['UserImageName'] ?? parsedUserImageName ?? null;

    const extension = this.userImageName?.split('.')[1]?.toLowerCase();
    let mimeType = 'image/png';
    if (extension === 'jpg' || extension === 'jpeg') mimeType = 'image/jpeg';
    this.imageUrl = `data:${mimeType};base64,${this.userImage}`;
  }

  public hexToBase64(hexString) {
    if (hexString == null) {
      return null; // handles both null and undefined
    }
    // Ensure the hex string is valid and has even length
    if (!hexString || hexString.length % 2 !== 0) {
      throw new Error('Invalid hex string');
    }
    // Convert hex to bytes
    const bytes = new Uint8Array(hexString.length / 2);
    for (let i = 0, j = 0; i < hexString.length; i += 2, j++) {
      bytes[j] = parseInt(hexString.substr(i, 2), 16);
    }
    // Convert bytes to binary string and encode to Base64
    const binaryString = String.fromCharCode(...bytes);
    return btoa(binaryString);
  }

  ngOnInit(): void {
    if (!this.service.isMenuLoaded) {
      this.service.init();
    }
  }

  // onMenuSelected() {
  //   $('.btnLeftNav').trigger('click');
  //   this.settingService.setSessionStorageValue('isMenuSelected', 'true');
  //   setScrollAndScreenHeight();
  // }

  onUserDropDownClick() {
    this.isUserDropdownOpen = !this.isUserDropdownOpen;
  }

  // onSettingOptionClicked(selectedSetting: MenuItem) {
  //   // this.isUserDropdownOpen = false;
  //   // console.log(selectedSetting);
  //   this.onMenuSelected();
  //   if (selectedSetting.code === 'SignOutAPI') {
  //     this.settingService.logoutUser();
  //   }
  // }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.service.isMenuLoaded = false;
    this.service.menuItems = [];
  }
}
